import {OrderPaymentStatus, OrderStage} from "../api";
import {Tag} from "antd";

const orderStageTranslations: { orderStage: OrderStage, translation: string }[] = [
    {orderStage: OrderStage.New, translation: "Nowe"},
    {orderStage: OrderStage.Sent, translation: "Wysłane"},
    {orderStage: OrderStage.Paid, translation: "Zapłacone"},
    {orderStage: OrderStage.Abandoned, translation: "Porzucone"},
    {orderStage: OrderStage.Canceled, translation: "Anulowane"},
    {orderStage: OrderStage.WaitingForPayment, translation: "Oczekujące na płatność"},
    {orderStage: OrderStage.Delivered, translation: "Dostarczone"},
    {orderStage: OrderStage.Confirmed, translation: "Potwierdzone"}
];

const orderPaymentStageTranslations: { paymentStage: OrderPaymentStatus, translation: string }[] = [
    {paymentStage: OrderPaymentStatus.Pending, translation: "W toku"},
    {paymentStage: OrderPaymentStatus.WaitingForConfimration, translation: "Oczekiwanie na potwierdzenie"},
    {paymentStage: OrderPaymentStatus.Canceled, translation: "Anulowana"},
    {paymentStage: OrderPaymentStatus.Completed, translation: "Zakończona"}
];

const OrderStageTag = (stage: OrderStage) => {
    switch (stage) {
        case OrderStage.New:
            return <Tag color="blue">{OrderStageTranslation(OrderStage.New)}</Tag>
        case OrderStage.Paid:
            return <Tag color="yellow">{OrderStageTranslation(OrderStage.Paid)}</Tag>
        case OrderStage.Sent:
            return <Tag color="cyan">{OrderStageTranslation(OrderStage.Sent)}</Tag>
        case OrderStage.Delivered:
            return <Tag color="green">{OrderStageTranslation(OrderStage.Delivered)}</Tag>
        case OrderStage.Abandoned:
            return <Tag color="red">{OrderStageTranslation(OrderStage.Abandoned)}</Tag>
        case OrderStage.Canceled:
            return <Tag color="red">{OrderStageTranslation(OrderStage.Canceled)}</Tag>
        case OrderStage.WaitingForPayment:
            return <Tag color="orange">{OrderStageTranslation(OrderStage.WaitingForPayment)}</Tag>
        case OrderStage.Confirmed:
            return <Tag color="green">{OrderStageTranslation(OrderStage.Confirmed)}</Tag>
    }
}

const OrderPaymentTag = (stage: OrderPaymentStatus) => {
    switch (stage) {
        case OrderPaymentStatus.Pending:
            return <Tag color={"blue"}>{OrderPaymentStageTranslation(OrderPaymentStatus.Pending)}</Tag>
        case OrderPaymentStatus.WaitingForConfimration:
            return <Tag color={"orange"}>{OrderPaymentStageTranslation(OrderPaymentStatus.WaitingForConfimration)}</Tag>
        case OrderPaymentStatus.Completed:
            return <Tag color={"green"}>{OrderPaymentStageTranslation(OrderPaymentStatus.Completed)}</Tag>
        case OrderPaymentStatus.Canceled:
            return <Tag color={"red"}>{OrderPaymentStageTranslation(OrderPaymentStatus.Canceled)}</Tag>

    }
}

const OrderStageTranslation = (orderStage: OrderStage) =>
    orderStageTranslations.find(x => x.orderStage === orderStage)?.translation || "";

const OrderPaymentStageTranslation = (paymentStage: OrderPaymentStatus) =>
    orderPaymentStageTranslations.find(x => x.paymentStage === paymentStage)?.translation || "";

export default OrderStageTranslation;

export {OrderPaymentTag, OrderStageTag, OrderPaymentStageTranslation};